"use strict";
var _a;
exports.__esModule = true;
exports.StatusColorMap = exports.HiylloSoloStatuses = exports.HiylloWorkStatuses = exports.AllStatuses = void 0;
var task_item_1 = require("@hiyllo/omni-common/src/types/tasks/task-item");
exports.AllStatuses = [
    { id: "todo", label: "To-Do", color: task_item_1.TaskStatusColorEnum.gray },
    { id: "inprogress", label: "In Progress", color: task_item_1.TaskStatusColorEnum.blue },
    { id: "inreview", label: "In Review", color: task_item_1.TaskStatusColorEnum.blue },
    { id: "done", label: "Done", color: task_item_1.TaskStatusColorEnum.green },
    { id: "wontdo", label: "Wont Do", color: task_item_1.TaskStatusColorEnum.red },
];
exports.HiylloWorkStatuses = [
    { id: "todo", label: "To-Do", color: task_item_1.TaskStatusColorEnum.gray },
    { id: "inprogress", label: "In Progress", color: task_item_1.TaskStatusColorEnum.blue },
    { id: "inreview", label: "In Review", color: task_item_1.TaskStatusColorEnum.blue },
    { id: "done", label: "Done", color: task_item_1.TaskStatusColorEnum.green },
    { id: "wontdo", label: "Wont Do", color: task_item_1.TaskStatusColorEnum.red },
];
exports.HiylloSoloStatuses = [
    { id: "todo", label: "To-Do", color: task_item_1.TaskStatusColorEnum.gray },
    { id: "inprogress", label: "In Progress", color: task_item_1.TaskStatusColorEnum.blue },
    { id: "done", label: "Done", color: task_item_1.TaskStatusColorEnum.green },
];
exports.StatusColorMap = (_a = {},
    _a[task_item_1.TaskStatusColorEnum.amber] = "#f57c00",
    _a[task_item_1.TaskStatusColorEnum.blue] = "#1976d2",
    _a[task_item_1.TaskStatusColorEnum.gray] = "gray",
    _a[task_item_1.TaskStatusColorEnum.green] = "#388e3c",
    _a[task_item_1.TaskStatusColorEnum.red] = "#d32f2f",
    _a);
